var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
import { greys } from "../../global/colors";
import { Lato } from "../../global/fonts";
export var bodyText = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n"], ["\n  ", "\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n"])), Lato, greys.mediumDark);
var templateObject_1;
